(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerWrapper = document.querySelector('.header-wrapper');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector('predictive-search');

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		if (this.header) {
			observer.observe(this.header);
		}
	}

	onScroll() {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
		this.header.classList.add('shopify-section-header-sticky','shopify-section-header-always-sticky');
		this.header.style.transform = 'translateY(-100%)';
	};

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 2) {
		this.header.classList.remove('color-background-3');
		this.header.style.transition = 'background var(--duration-short), transform var(--duration-default)';
		this.header.style.transform = 'translateY(0)';
	};

	if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
		this.header.classList.remove('shopify-section-header-sticky');
		this.header.style.transform = 'translateY(0)';
		this.header.style.transition = 'background var(--duration-short)';
		if (this.header.classList.contains('color-background-1')) {
		this.header.classList.add('color-background-3');
		};
	};

	if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (this.preventHide) return;
		requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (!this.preventReveal) {
		requestAnimationFrame(this.reveal.bind(this));
		} else {
			window.clearTimeout(this.isScrolling);

			this.isScrolling = setTimeout(() => {
			this.preventReveal = false;
			}, 66);

			requestAnimationFrame(this.hide.bind(this));
		}
		} else if (scrollTop <= this.headerBounds.top) {
		requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden','color-background-3');
	}

	reset() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
		if (this.header.classList.contains('color-background-1')) {
			this.header.classList.add('color-background-3');
		};
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		if (this.disclosures) {
			this.disclosures.forEach(disclosure => {
				disclosure.close();
			});
		}
		this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			if (this.disclosureLists) {
				this.disclosureLists.forEach(disclosureList => {
					disclosureList.setAttribute('hidden', true);
				});
			}
		}
	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
class ProductModal extends ModalDialog {
	constructor() {
		super();
	}

	hide() {
		super.hide();
		window.pauseAllMedia();
	}

	show(opener) {
		super.show(opener);
		this.showActiveMedia();
	}

	showActiveMedia() {
		const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);

		if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
			activeMedia.loadContent();
	}
}

customElements.define('product-modal', ProductModal);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  class SetteRecsProgress {
    constructor(section) {
      this.section = section;
      this.carousel = section.querySelector('[data-carousel]');
      this.progressFill = section.querySelector('[data-progress-fill]');
      if (!this.carousel) return;
      this.init();
    }

    init() {
      this.updateProgress();
      this.carousel.addEventListener('scroll', () => this.updateProgress(), { passive: true });
      window.addEventListener('resize', () => this.updateProgress());
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => this.updateProgress());
      }
      setTimeout(() => this.updateProgress(), 100);
    }

    updateProgress() {
      if (!this.progressFill || !this.carousel) return;
      var progressContainer = this.section.querySelector('.sette-recs-progress');
      var scrollableWidth = this.carousel.scrollWidth - this.carousel.clientWidth;
      if (scrollableWidth <= 1) {
        if (progressContainer) progressContainer.classList.add('is-hidden');
        return;
      }
      if (progressContainer) progressContainer.classList.remove('is-hidden');
      var visibleRatio = this.carousel.clientWidth / this.carousel.scrollWidth;
      var scrollRatio = this.carousel.scrollLeft / scrollableWidth;
      var fillWidth = visibleRatio * 100;
      var trackTravel = 100 - fillWidth;
      var fillLeft = scrollRatio * trackTravel;
      this.progressFill.style.width = fillWidth + '%';
      this.progressFill.style.left = fillLeft + '%';
    }
  }

  function initSetteRecsProgress() {
    // Matches both variants: the AJAX <product-recommendations> element and the
    // server-rendered collection <div>. Without [data-sette-recs] the progress
    // bar would never initialise in collection mode.
    document.querySelectorAll('product-recommendations, [data-sette-recs]').forEach(function (section) {
      if (section.dataset.recsProgressInit) return;

      // Try immediately in case content is already rendered
      var carousel = section.querySelector('[data-carousel]');
      if (carousel) {
        section.dataset.recsProgressInit = 'true';
        new SetteRecsProgress(section);
        return;
      }

      // Recommendations load via AJAX — watch for the carousel to appear
      var observer = new MutationObserver(function (mutations, obs) {
        var c = section.querySelector('[data-carousel]');
        if (c) {
          obs.disconnect();
          section.dataset.recsProgressInit = 'true';
          new SetteRecsProgress(section);
        }
      });
      observer.observe(section, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSetteRecsProgress);
  } else {
    initSetteRecsProgress();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector && (e.target.querySelector('product-recommendations') || e.target.querySelector('[data-sette-recs]'))) {
      initSetteRecsProgress();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sette-how-to-style"] && !Shopify.designMode) return;
  try {
    
class SetteHowToStyle {
  constructor(section) {
    this.section = section;
    this.carousel = section.querySelector('[data-carousel]');
    this.progressFill = section.querySelector('[data-progress-fill]');
    if (!this.carousel) return;
    this.init();
  }

  init() {
    this.updateProgress();
    this.carousel.addEventListener('scroll', () => this.updateProgress(), { passive: true });
    window.addEventListener('resize', () => this.updateProgress());
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => this.updateProgress());
    }
    setTimeout(() => this.updateProgress(), 100);
  }

  updateProgress() {
    if (!this.progressFill || !this.carousel) return;
    var progressContainer = this.section.querySelector('.sette-howto-progress');
    var scrollableWidth = this.carousel.scrollWidth - this.carousel.clientWidth;
    if (scrollableWidth <= 1) {
      // Nothing to scroll — hide the bar entirely
      if (progressContainer) progressContainer.classList.add('is-hidden');
      return;
    }
    if (progressContainer) progressContainer.classList.remove('is-hidden');
    var visibleRatio = this.carousel.clientWidth / this.carousel.scrollWidth;
    var scrollRatio = this.carousel.scrollLeft / scrollableWidth;
    var fillWidth = visibleRatio * 100;
    var trackTravel = 100 - fillWidth;
    var fillLeft = scrollRatio * trackTravel;
    this.progressFill.style.width = fillWidth + '%';
    this.progressFill.style.left = fillLeft + '%';
  }
}

function initSetteHowToStyle() {
  document.querySelectorAll('.sette-howto-style').forEach(function (section) {
    if (!section.dataset.howtoInitialized) {
      new SetteHowToStyle(section);
      section.dataset.howtoInitialized = 'true';
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSetteHowToStyle);
} else {
  initSetteHowToStyle();
}

document.addEventListener('shopify:section:load', function (e) {
  if (e.target.querySelector && e.target.querySelector('.sette-howto-style')) {
    initSetteHowToStyle();
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sette-product-info-tabs"] && !Shopify.designMode) return;
  try {
    
class SetteProductInfoTabs {
  constructor(section) {
    this.section = section;
    this.tabs = section.querySelectorAll('.sette-tab');
    this.panels = section.querySelectorAll('.sette-tab-panel');
    this.underline = section.querySelector('.sette-tab-underline');
    this.tabsNav = section.querySelector('.sette-tabs-nav');
    this.init();
  }

  init() {
    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.activateTab(tab));
    });
    this.moveUnderline();
    window.addEventListener('resize', () => this.moveUnderline());
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => this.moveUnderline());
    }
    setTimeout(() => this.moveUnderline(), 100);
  }

  activateTab(tab) {
    var target = tab.dataset.tab;
    this.tabs.forEach((t) => {
      var isActive = t === tab;
      t.classList.toggle('is-active', isActive);
      t.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
    this.panels.forEach((p) => {
      p.classList.toggle('is-active', p.dataset.panel === target);
    });
    this.moveUnderline();
  }

  moveUnderline() {
    var activeTab = this.section.querySelector('.sette-tab.is-active');
    if (!activeTab || !this.underline || !this.tabsNav) return;
    var tabRect = activeTab.getBoundingClientRect();
    var navRect = this.tabsNav.getBoundingClientRect();
    this.underline.style.left = (tabRect.left - navRect.left) + 'px';
    this.underline.style.width = tabRect.width + 'px';
  }
}

function initSetteProductInfoTabs() {
  document.querySelectorAll('.sette-product-info-tabs').forEach(function (section) {
    if (!section.dataset.tabsInitialized) {
      new SetteProductInfoTabs(section);
      section.dataset.tabsInitialized = 'true';
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSetteProductInfoTabs);
} else {
  initSetteProductInfoTabs();
}

// Theme editor support
document.addEventListener('shopify:section:load', function (e) {
  if (e.target.querySelector && e.target.querySelector('.sette-product-info-tabs')) {
    initSetteProductInfoTabs();
  }
});

document.addEventListener('shopify:block:select', function (e) {
  var section = e.target.closest && e.target.closest('.sette-product-info-tabs');
  if (!section) return;
  var blockId = e.detail && e.detail.blockId;
  if (!blockId) return;
  var tab = section.querySelector('[data-tab="tab-' + blockId + '"]');
  if (tab) tab.click();
});

  } catch(e) { console.error(e); }
})();
})();
